import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Component to safely render messages that may contain HTML.
 * Only renders HTML when explicitly allowed from backend (already sanitized with wp_kses_post).
 */
export var SafeHtmlMessage = function (_a) {
    var message = _a.message, _b = _a.allowHtml, allowHtml = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c, role = _a.role;
    if (allowHtml) {
        // HTML has already been sanitized by wp_kses_post() on the backend
        return (_jsx("div", { className: className, role: role, dangerouslySetInnerHTML: { __html: message } }));
    }
    // Default: render as plain text
    return _jsx("div", { className: className, role: role, children: message });
};
